import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOTimeRanges } from "src/app/shared/models/OOTimeRanges.entity";
import { OOTimeRangeTimes } from "src/app/shared/models/OOTimeRangeTimes.entity";

@Component({
	selector: "app-time-range-setup",
	templateUrl: "./time-range-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class TimeRangeSetupComponent implements OnInit, OnDestroy {
	@Input() timeRangeSelected: OOTimeRanges;

	@Output() clearEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() saveEmitter: EventEmitter<OOTimeRanges> = new EventEmitter<OOTimeRanges>();

	copiedRow: OOTimeRangeTimes;

	moment: any = moment;

	constructor(public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.timeRangeSelected.OOTimeRangeTimes.forEach((trt) => {
			trt.startTime = trt.startTime ? (trt.startTime === "00:00" ? undefined : moment(trt.startTime, "HH:mm").toDate()) : undefined;
			trt.endTime = trt.endTime ? (trt.endTime === "00:00" ? undefined : moment(trt.endTime, "HH:mm").toDate()) : undefined;
			trt.startTime2 = trt.startTime2 ? (trt.startTime2 === "00:00" ? undefined : moment(trt.startTime2, "HH:mm").toDate()) : undefined;
			trt.endTime2 = trt.endTime2 ? (trt.endTime2 === "00:00" ? undefined : moment(trt.endTime2, "HH:mm").toDate()) : undefined;
		});
		for (let i = 0; i < 7; i++) {
			if (!this.timeRangeSelected.OOTimeRangeTimes.some((trt) => trt.day === i)) {
				this.timeRangeSelected.OOTimeRangeTimes.push(
					new OOTimeRangeTimes({
						timeRangeKey: this.timeRangeSelected.key,
						venueKey: this.timeRangeSelected.venueKey,
						day: i,
					})
				);
			}
		}

		this.timeRangeSelected.OOTimeRangeTimes.sort((a, b) => (a.day > b.day ? 1 : -1));
	}

	ngOnDestroy() {
		if (this.timeRangeSelected.name) {
			this.timeRangeSave();
		}
	}

	copyTimeRangeTimeRow(day: number) {
		this.copiedRow = { ...this.timeRangeSelected.OOTimeRangeTimes.find((i) => i.day === day) };
	}

	cancelCopyTimeRangeRow() {
		this.copiedRow = undefined;
	}

	pasteTimeRangeTimeRow(day: number) {
		const targetRow = this.timeRangeSelected.OOTimeRangeTimes.find((i) => i.day === day);
		const cr = { ...this.copiedRow };
		targetRow.endTime = cr.endTime;
		targetRow.endTime2 = cr.endTime2;
		targetRow.startTime = cr.startTime;
		targetRow.startTime2 = cr.startTime2;
	}

	timeRangeSave() {
		if (!this.timeRangeSelected.isFromPos) {
			this.timeRangeSelected.OOTimeRangeTimes = this.timeRangeSelected.OOTimeRangeTimes.map((i) => {
				const trt = new OOTimeRangeTimes(i);
				trt.endTime = trt.endTime ? moment(trt.endTime).format("HH:mm") : undefined;
				trt.startTime = trt.startTime ? moment(trt.startTime).format("HH:mm") : undefined;
				trt.startTime2 = trt.startTime2 ? moment(trt.startTime2).format("HH:mm") : undefined;
				trt.endTime2 = trt.endTime2 ? moment(trt.endTime2).format("HH:mm") : undefined;

				return trt;
			});
			this.venueSvc.timeRangesSave(this.timeRangeSelected);
		}

		this.saveEmitter.emit(this.timeRangeSelected);
	}
}
